export default function getPrices(amountBgn) {
  const priceBgn = parseFloat(amountBgn);
  const priceEur = priceBgn / 1.95583;

  return {
    priceBgn,
    priceEur
  };
}
